import { memo } from 'react';

import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';

import styles from './KnmPreview.module.scss';
import { KnmSubtitle } from './KnmSubtitle';

interface IPmResultProps {
  passportData: IKnmPreview;
}

export const PmResult = memo(({ passportData }: IPmResultProps) => (
  <div className={styles.ColumnContent}>
    {passportData.pmErknm && passportData.pmErknm.resultOfInspection && (
      <KnmSubtitle title="Сведения о результатах профилактического мероприятия">
        {passportData.erpId && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Результат профилактического мероприятия</div>
            <div className={styles.ColValue}>{passportData.pmErknm.resultOfInspection}</div>
          </div>
        )}
      </KnmSubtitle>
    )}
  </div>
));
